import { type UseQueryResult, useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { type BadgeReward } from 'src/types/api'

export const useGetAllLocationBadges = (): UseQueryResult<BadgeReward[]> => {
  const get = useTypedApiClient({
    path: '/le-connect/badgerewards/locationBadges',
    method: 'get',
  })

  return useQuery({
    queryKey: ['/le-connect/badgerewards/locationBadges'],
    queryFn: async () => {
      const { data } = await get({})
      return data
    },
  })
}
